/**
 * Utilities for initializing agent connections based on agent metadata
 */
export class ChatConnectionsInitUtils {
  /**
   * Determine which connections should be active for an agent
   * based on agent name, category, and custom configs
   */
  static getConnectionsForAgent(agent: any): string[] {
    const connections: string[] = [];
    const agentName = (agent.agent_config?.name || '').toLowerCase();
    const agentCategory = agent.category || '';
    const typeAgentFromStorage = localStorage.getItem('type_agent');

    // Verificar si tiene agent_datasource en agent_custom_configs
    if (agent.agent_config?.agent_custom_configs) {
      agent.agent_config.agent_custom_configs.forEach((config: any) => {
        if (config.agent_datasource) {
          // El agente tiene un datasource conectado -> mostrar database
          if (!connections.includes('database')) {
            connections.push('database');
          }
        }
      });
    }

    // Si ya no tiene conexiones asignadas, aplicar lógica basada en nombre
    if (connections.length === 0) {
      // Dirección / CEO → Todas las conexiones estratégicas
      if (agentName.includes('dirección') || agentName.includes('direccion') || agentName.includes('ceo') || agentName.includes('director')) {
        connections.push('database', 'mirai', 'a3erp', 'odoo_mcp', 'a3innuva', 'outlookcalendar', 'sharepoint', 'boe');
      }
      // Experto RRHH → HRLog, A3Innuva, Sharepoint, BOE
      else if (agentName.includes('experto rrhh') || agentName.includes('experto de rrhh')) {
        connections.push('hrlog', 'a3innuva', 'sharepoint', 'boe');
      }
      // Experto Comercial → Mirai, A3 ERP, Odoo, Base de datos
      else if (agentName.includes('experto comercial') || agentName.includes('comercial')) {
        connections.push('database', 'mirai', 'a3erp', 'odoo_mcp');
      }
      // Experto Financiero → Mirai, A3 ERP, Odoo, A3Innuva, Outlook Calendar, Base de datos, BOE
      else if (agentName.includes('experto financiero') || agentName.includes('financiero')) {
        connections.push('database', 'mirai', 'a3erp', 'odoo_mcp', 'a3innuva', 'outlookcalendar', 'boe');
      }
      // Experto Clientes → Mirai, A3 ERP, Odoo, Outlook, Outlook Calendar, Sharepoint
      else if (agentName.includes('experto clientes') || agentName.includes('clientes')) {
        connections.push('database', 'mirai', 'a3erp', 'odoo_mcp', 'outlook', 'outlookcalendar', 'sharepoint');
      }
      // Experto Administrativo → Mirai, A3 ERP, Odoo, Outlook, Outlook Calendar, Sharepoint, BOE
      else if (agentName.includes('experto administrativo') || agentName.includes('administrativo')) {
        connections.push('database', 'mirai', 'a3erp', 'odoo_mcp', 'outlook', 'outlookcalendar', 'sharepoint', 'boe');
      }
      // Experto Operaciones → Mirai, A3 ERP, Odoo, Sharepoint, Base de datos
      else if (agentName.includes('experto operaciones') || agentName.includes('operaciones')) {
        connections.push('database', 'mirai', 'a3erp', 'odoo_mcp', 'sharepoint');
      }
      // Asistente Ardia → Outlook, Outlook Calendar
      else if (agentName.includes('asistente ardia')) {
        connections.push('outlook', 'outlookcalendar');
      }
      // Legacy: SQL Asistant -> HRLOG (mantener compatibilidad)
      else if (agentName.includes('sql asistant') || agentName.includes('sql assistant') ||
        agentName.includes('vacaciones hrlog') || agentName.includes('hrlog')) {
        connections.push('hrlog');
      }
      // Legacy: Soporte -> Base de datos (mantener compatibilidad)
      else if (agentName.includes('soporte')) {
        connections.push('database');
      }
      // Legacy: BOE -> BOE (mantener compatibilidad)
      else if (agentName.includes('boe')) {
        connections.push('boe');
      }
      // Si es un datasource (por categoría o localStorage), mostrar database
      else if (agentCategory === 'datasources' || typeAgentFromStorage === 'datasource') {
        connections.push('database');
      }
    }

    return connections;
  }
}
